import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import DocumentTemplateTableSection from '../../components/DocumentTemplate/DocumentTemplateTableSection';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const ElectronicDocumentTemplate = () => {
  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Plantillas de Documentos Electrónicos" /> */}
      <BreadcrumbTwo />

      <DocumentTemplateTableSection/>
    </DefaultLayout>
  );
};

export default ElectronicDocumentTemplate;
